import { z } from 'zod';

import { zodContractVersionPageBaseSchema } from '../validations';

/**
 * Validation schemas for the items stored with a contract version.
 */

// The stored items are a point-in-time snapshot whose shape follows the item
// model of the time, so each record is kept as the server sent it.
export const zodContractHistoryVersionItemsResponseSchema =
  zodContractVersionPageBaseSchema.extend({
    data: z.array(z.record(z.string(), z.json())),
  });
